import { useNavigate } from "react-router-dom";
import { Play } from "lucide-react";
import personStandingIcon from "../assets/icons/user.svg";
import sparklesIcon from "../assets/icons/sparkles.svg";
import phoneCallIcon from "../assets/icons/phonecall.svg";
import disclaimerIcon from "../assets/icons/disclaimer icon.svg";
import { VIDEO_URLS } from "../config/constants.js";
import useAuth from "@/hooks/stores/useAuth";

export default function WelcomeVideo() {
  const navigate = useNavigate();
  const { setUserFlow, isAuthenticated, paymentStatus } = useAuth();

  const handleInPersonRecording = () => {
    // Set user flow to in-person before navigation
    setUserFlow('in-person');
    navigate('/in-person-booking');
  };

  const handleRemoteCall = () => {
    // Set user flow to remote before navigation
    setUserFlow('remote');
    
    // If user is authenticated and has valid payment status, go directly to assisted recording
    // If user has failed payment or is not authenticated, start from remote call selection
    if (isAuthenticated && paymentStatus !== 'failed') {
      navigate('/assisted-recording');
    } else {
    navigate('/remote-call');
    }
  };

  const handleNextStep = () => {
    // Default to in-person if no selection made
    setUserFlow('in-person');
    navigate('/in-person-booking');
  };

  return (
    <div className="min-h-screen bg-background pt-9">
      {/* Main Content */}
      <div className="max-w-2xl mx-auto px-4">
        {/* Video Section */}
        <div className="bg-secondary border border-secondary-border rounded-lg p-5 mb-6">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-[42.66px] h-[42.66px] rounded-[8px] flex items-center justify-center">
              <img src={disclaimerIcon} alt="Disclaimer" className="w-full h-full" />
            </div>
            <p className="text-base font-semibold text-foreground">Press play to get started.</p>
          </div>
          <p className="text-foreground text-base font-normal">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sollicitudin, mi et
            mattis venenatis, turpis metus ornare erat, vestibulum mollis mi enim eu dolor.
          </p>
        </div>

        {/* Video Player */}
        <div className="aspect-[16/9] bg-black rounded-xl overflow-hidden mb-6 relative">
          <iframe
            src={VIDEO_URLS.INTRO_VIDEO}
            className="w-full h-full"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            title="Intro Video"
          />
        </div>

        {/* Options Grid */}
        <div className="grid grid-cols-3 gap-6 mb-6">
          <button 
            onClick={handleInPersonRecording}
            className="h-[139px] bg-primary text-primary-foreground rounded-[8px] p-6 flex flex-col items-center justify-center gap-6 hover:bg-primary/90 transition-colors"
          >
            <div className="w-[45px] h-[45px] bg-background border border-secondary-border rounded-[8px] p-1.5 flex items-center justify-center">
              <img src={personStandingIcon} alt="In Person" className="object-contain w-[18px] h-[18px]" />
            </div>
            <span className="text-base font-semibold">In Person</span>
          </button>

          <button disabled className="h-[139px] bg-muted text-muted-foreground rounded-[8px] p-6 flex flex-col items-center justify-center gap-6 cursor-not-allowed opacity-50">
            <div className="w-[45px] h-[45px] bg-background border border-secondary-border rounded-[8px] p-1.5 flex items-center justify-center opacity-50">
              <img src={sparklesIcon} alt="CarrieBot" className="w-[18px] h-[18px] grayscale" />
            </div>
            <span className="text-base font-semibold">CarrieBot</span>
          </button>

          <button 
            onClick={handleRemoteCall}
            className="h-[139px] bg-primary text-primary-foreground rounded-[8px] p-6 flex flex-col items-center justify-center gap-6 hover:bg-primary/90 transition-colors"
          >
            <div className="w-[45px] h-[45px] bg-background border border-secondary-border rounded-[8px] p-1.5 flex items-center justify-center">
              <img src={phoneCallIcon} alt="Remote Call" className="w-[18px] h-[18px]" />
            </div>
            <span className="text-base font-semibold">Remote Call</span>
          </button>
        </div>

        {/* Next Step Button */}
        <button 
          onClick={handleNextStep}
          className="w-full py-4 mb-4 bg-primary border border-primary-border text-primary-foreground rounded-lg text-base font-semibold hover:bg-primary/90 transition-colors flex items-center justify-center"
        >
          Next Step
          <svg className="w-5 h-5 ml-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
  );
} 